import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HomepageDataService } from 'src/app/services/homepageData/homepageData.service';
import { Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';



@Component({
  selector: 'app-distributor-dashboard',
  templateUrl: './distributor-dashboard.component.html',
  styleUrls: ['./distributor-dashboard.component.scss'],
})
export class DistributorDashboardComponent implements OnInit {

@ViewChild(BaseChartDirective) tankPieChart?: BaseChartDirective;
@ViewChild(BaseChartDirective) tankBarChart?: BaseChartDirective;
@ViewChild(BaseChartDirective) unitPieChart?: BaseChartDirective;
@ViewChild(BaseChartDirective) unitBarChart?: BaseChartDirective;

  isLoading: boolean = false;
  userDistId?: number;
  tankLevelPercent?: number = 31;
  consumptionPercent: number = 62;
  averageLevel: number = 0;
  totalCapacity: number = 0;
  totalUnits: number = 0;
  totalCustomers: number = 0;
  onlineUnits: number = 0;
  unitsNotReporting: number = 0;
  totalTanks: number = 0;
  monitoredTanks: number = 0;
  unmonitoredTanks: number = 0;
  totalCapacityPercentage: number = 0;
  activeTab: string = 'tanks'; // default
  tankStats: any[] = [];
  deviceStats: any[] = [];
  tanks: any[] = [];

  // Tank Bar chart bindings
  public tankBarData: any[] = [];
  public tankBarLabels: string[] = [];
  public tankBarChartType = 'bar';
  public tankBarOptions: any = {
    responsive: true,
    animation: { duration: 1000 },
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true }
      }]
    },
    legend: { display: false },
    labels: {
      fontColor: '#000'
    }
  };

  // Tank Pie chart bindings
  public tankPieLabels: string[] = ['Monitored Tanks', 'Unmonitored Tanks'];
  public tankPieData: number[] = [];
  public tankPieType: string = 'pie'; 
  public tankPieOptions: any = {
    responsive: true,
    legend: {
      position: 'bottom',
      labels: {
        fontColor: '#000'
      }
    }
  };
  public tankPieColors: any[] = [{
    backgroundColor: ['#4a90e2', '#cfd8dc'] // Blue and light grey
  }];

  // Unit bar chart bindings
  public deviceBarData: any[] = [];
  public deviceBarLabels: string[] = [];
  public deviceBarChartType = 'bar';
  public deviceBarOptions = {
    responsive: true,
    animation: { duration: 1000 },
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true }
      }]
    },
    legend: { display: false },
    labels: {
      fontColor: '#000'
    }
  };

  //Unit pie chart bindings
  public devicePieLabels: string[] = ['Activated', 'Deactivated', 'Inactive'];
  public devicePieData: number[] = [];
  public devicePieChartType: string = 'pie';
  public devicePieOptions: any = {
    responsive: true,
    legend: {
      position: 'bottom'
    },
    labels: {
      fontColor: '#000'
    }
  };
  public devicePieColors: any[] = [
    {
      backgroundColor: ['#4a90e2', '#cfd8dc', '#90caf9']
    }
  ];


  getTankColor(level: number): string {
    if (level <= 20) return '#dc2626'; // red
    if (level <= 40) return '#facc15'; // yellow
    return '#22c55e'; // green
  }


  constructor(
    private _authorizeService: AuthorizeService,
    private _router: Router,
    private _homepageDataService: HomepageDataService) {
    this._authorizeService.user$.subscribe(user => {
      this.userDistId = user?.distributorId;
    });
  }

  ngOnInit() {
    this.isLoading = true;
      this._homepageDataService.getHomepageTanks$(this.userDistId!).pipe(
        map((data: any) => {
            this.averageLevel = data.avgPropaneLevel;
            this.totalTanks = data.totalTanks;

            //tank bar chart data
            const avgData = data.avgPropaneLevelByMonth || [];
            this.tankBarLabels = avgData.map((item: { monthLabel: any; }) => item.monthLabel);
            const tankValues = avgData.map((item: { value: number; }) => parseFloat(item.value.toFixed(2))); // Round to 2 decimals
            this.tankBarData = [
                {
                    data: tankValues,
                    label: 'Avg Propane Level (%)',
                    backgroundColor: 'rgba(54, 162, 235, 0.7)',
                    hoverBackgroundColor: '#cfd8dc'
                }
            ];
            this.tankBarChart?.update();

            //tank pie data
            this.monitoredTanks = data.monitoredTanks;
            this.unmonitoredTanks = this.totalTanks - this.monitoredTanks;
            this.tankPieData = [this.monitoredTanks, this.unmonitoredTanks];
            this.tankPieChart?.update();

            this.tankStats = [
                { label: 'Tanks Critical Low', value: data.criticalLow },
                { label: 'Tanks Time For Delivery', value: data.timeForDelivery },
                { label: 'Tanks 10% Drop', value: data.tenPercentDrop },
                //{ label: 'Watchlist Tanks', value: data.watchlistTanks },
                { label: 'Tanks Total Capacity', value: `${data.totalCapacity.toLocaleString()} gal` }
            ];

            this.deviceStats = [
                { label: 'Total Customers', value: data.totalCustomers },
                { label: 'Total Units', value: data.totalUnits },
                { label: 'Assigned Units', value: data.monitoredTanks },
                //{ label: 'Units Not Reporting', value: data.unitsNotReporting }
            ];

            //Unit bar chart
            const usage = data.unitActivationsByMonth || [];
            this.deviceBarLabels = usage.map((x: { monthLabel: any; }) => x.monthLabel);
            const unitValues = usage.map((x: { value: any; }) => x.value);
            this.deviceBarData = [
                {
                    data: unitValues,
                    label: 'Activated',
                    backgroundColor: 'rgba(54, 162, 235, 0.7)',
                    hoverBackgroundColor: '#cfd8dc'
                }
            ];
            this.unitBarChart?.update();

            //Unit pie chart
            this.devicePieData = [data.activatedUnits, data.deactivatedUnits, data.inactiveUnits];
            this.unitPieChart?.update();

            //Lowest 5 tanks
            const rawTanks = data.lowestLevelTanks || [];
            this.tanks = rawTanks.map((tank: any) => ({
                id: tank.tankId,
                tankSerialNumber: tank.tankSerialNumber,
                capacity: tank.capacity,
                level: tank.level
            }));

            return data;
        })
      ).subscribe();
      this.isLoading = false;
  }


//charts area
setTab(tab: string): void {
  this.activeTab = tab;
}

get hasTanks(): boolean {
  return this.tanks && this.tanks.length > 0;
}


navigateFromStat(label: string) {
    if (label == 'Total Customers')
        this._router.navigate(['/dashboard/customers/customers']);
    else
        this._router.navigate(['/dashboard/tanks/tanks']);
  }


  getVisualTankHeight(level: number): string {
  const visualLevel = Math.max(level, 7); // enforce a minimum of 5%
  return visualLevel + '%';
}


}
